import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { Autocomplete, TextField, Grid, Button, Stack, IconButton, Typography } from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import DisplayPage from "../../components/Views/Display/DisplayPage";
import StyledDataGrid from "../../components/DataGrid";
import Switch from '@mui/material/Switch';

// import { actions as commonActions } from "../../store/actions";
import { actions } from "./state/actions";
import { actions as partnerActions } from "../Partners/state/actions";
import "./SellableProduct.scss";

const SellableProduct = () => {
  const { t } = useTranslation();
  const state = useSelector((state) => state.sellableProduct);
  const partnersState = useSelector((state) => state.partners);
  const commonState = useSelector((state) => state.common);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [popupContent, setPopupContent] = useState({});
  const [fields, setFields] = useState({
    partner: null
  });
  const handlePopupVisibility = (data) => {
    setPopupContent(data);
    setOpen(true);
  }
  const handleChange = (event, PartnerProductSK) => {
    //setChecked(event.target.checked);
    //alert(event.target.checked + "/" + PartnerProductSK + "/"+fields?.partner?.PartnerSK);
    const strSellable = event.target.checked ? "Yes" : "No";
    if (confirm("Do you want to saleable - " + strSellable + " ?")) {
      console.log("Partner Selection",fields?.partner?.PartnerSK);
      const Param = {
        partnerSK: fields?.partner?.PartnerSK,
        partnerProductSK: PartnerProductSK,
        body: {
          PartnerProductIsSellable: event.target.checked ? 1 : 0,
          updatedBy: commonState?.userInfo?.principalName
        }
      };
      dispatch(actions.updateProductPartner(Param));
    }

  };

  const columns = [
    { flex: 1, field: 'ProductCode', headerName: t(`FA Code`), headerClassName: "dgHeader", width: 150 },
    { flex: 2, field: 'ProductDescription', headerName: t(`Description`), headerClassName: "dgHeader", width: 200 },
    { flex: 1, field: 'EANCode', headerName: t(`EANCode`), headerClassName: "dgHeader", width: 150 },
    { flex: 1, field: 'PartnerName', headerName: t(`Ezd Name`), headerClassName: "dgHeader", width: 100 },
    {
      flex: 1, field: 'PartnerProductIsSellable', headerName: t(`Saleable`), headerClassName: "dgHeader", width: 100, renderCell: ({ row }) => <Switch
        checked={row?.PartnerProductIsSellable == 1 ? true : false}
        onChange={(e) => handleChange(e, row?.PartnerProductSK)}
        inputProps={{ 'aria-label': 'controlled' }}
      />
    },
    // { flex: 1, field: 'CreatedDate', headerName: t(`Created Date`), headerClassName: "dgHeader", width: 100, renderCell: (param) => moment(param.value).format("YYYY-MM-DD") },
  ];

  const handleClose = () => {
    setOpen(false);
    setPopupContent({});
  }

  const handleInputFieldChange = (name, value) => {
    setFields({
      ...fields,
      [name]: value
    });
    dispatch(actions.getProductsByPartner({ eanCode: "", partnerSK: value?.PartnerSK }));
  }

  useEffect(() => {

    if (partnersState?.data && partnersState.data.length === 0) {
      dispatch(partnerActions.getDistributorOptions());
    }
  }, []);

  useEffect(() => {
    if (partnersState?.data.length > 0) {
      const firstPartner = partnersState?.data[0];
      setFields({
        ...fields,
        ["partner"]: firstPartner
      });
      dispatch(actions.getProductsByPartner({ eanCode: "", partnerSK: firstPartner?.PartnerSK }));
    }
  }, [partnersState?.data]);

  useEffect(() => {
    console.log("Products data.", state?.data);
  }, [state?.data]);

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={state?.puzzleLoader || false}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <DisplayPage>
        <Grid sx={{ flexDirection: 'column' }} container spacing={2}>
          <Grid item sx={{ pl: 1, mt: 1, mb: 2, display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{t('Saleable Product')}</Typography>
          </Grid>
        </Grid>
        <>
          <Grid container spacing={2}>
            <Grid item sm={6}>
              <Autocomplete
                size="small"
                disablePortal
                id="partner"
                name="partner"
                options={partnersState?.data || []}
                value={fields.partner}
                onChange={(e, value) => handleInputFieldChange('partner', value)}
                // getOptionLabel={(option) => option.PartnerName}
                getOptionLabel={(option) => `${(option.PartnerPortalName) ? option.PartnerPortalName : option.PartnerCode }`}
                renderInput={(params) => <TextField {...params} fullWidth label={t("Partner Portal Name")} />}
              />
            </Grid>
            <Grid item sm={12}>
              <div style={{
                height: '670px',
                width: '100%'
              }}>

                <StyledDataGrid
                  columns={columns}
                  rows={state?.data || []}
                  getRowId={(row) => row.PartnerProductSK}
                  loading={commonState?.loading || false}
                  csvOptions={{
                    fileName: 'Products'
                  }}
                />
              </div>
            </Grid>

          </Grid>
        </>
      </DisplayPage>
    </>
  );
};

export default SellableProduct;
